import FeatherIcon from "feather-icons-react"
import { useState } from "react";
import { formatMoneyWithCurrency } from "src/utils/formatter";
import moment from "moment";
import { GetSII12MonthsPurchases, GetSII12MonthsSales, GetSIILast12MonthsPurchases, GetSIILast12MonthsSales } from "src/graphql/dashboard";
import { DropdownBalances } from "./DropdownBalances";
import { GetCompanyData } from "src/graphql/company";


export const ResumeBalances = ({ source, companyId }) => {

  const { data } = GetCompanyData(companyId)
  const companyData = data?.Company

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const result = source.reduce((acc, item) => {
    const currency = item.currencyType; // "CLP" o "USD"

    if (!acc[currency]) {
      acc[currency] = {
        currencyType: currency,
        totalAvailableBalance: 0,
        totalCreditLineAvailable: 0,
        count: 0,
      };
    }

    acc[currency].totalAvailableBalance += item.availableBalance;
    acc[currency].totalCreditLineAvailable += item.creditLineAvailable;
    acc[currency].count += 1;

    return acc;
  }, {});


  return (
    <>
      <div className="tw-bg-gray-100 tw-rounded-md tw-border-solid tw-border-[1px] tw-border-gray-200 tw-w-full tw-py-4 tw-px-6 tw-min-h-[83px]"
      >
        <div className="tw-flex tw-justify-between tw-cursor-pointer" onClick={toggleExpand}>
          <div className="tw-flex tw-flex-col tw-gap-2">
            <p className="tw-font-medium tw-text-lg tw-text-black !tw-p-0 !tw-m-0">{companyData?.alias || companyData?.name || ''}</p>
            <p className="tw-font-normal tw-text-gray-600 !tw-p-0 !tw-m-0 tw-capitalize">Saldo total</p>
          </div>
          <div className="tw-flex tw-items-center tw-gap-2">
            <div className="tw-flex tw-flex-col tw-items-end tw-gap-1">
              {Object.values(result).map((currencyData) => (
                <p
                  key={currencyData.currencyType}
                  className={`!tw-p-0 !tw-m-0 tw-font-medium tw-text-lg tw-text-black`}
                >
                  {formatMoneyWithCurrency(
                    currencyData.totalAvailableBalance,
                    currencyData.currencyType
                  )}
                </p>
              ))}
            </div>
            <FeatherIcon icon={`${isExpanded ? 'chevron-down' : 'chevron-right'}`} size={20} className="tw-text-gray-600" strokeWidth={2.5} />
          </div>
        </div>
        <div className={`tw-transition-all tw-duration-300 tw-ease-in-out tw-mt-5 ${isExpanded ? 'tw-block' : 'tw-hidden'}`}>
          <div className="tw-bg-white tw-rounded-md tw-pb-2">
            <DropdownBalances
              companyId={companyId}
              source={source}
            />
          </div>
        </div>
      </div>
    </>
  )
}